/**
 * Utility functions for handling target codes.
 * Centralizes formatting logic to avoid duplication across components.
 */

/**
 * Format a target code as XXXX-XXXX
 * @param code - The raw target code string
 * @returns Formatted code with dash separator
 */
export const formatTargetCode = (code: string): string => {
  if (!code) return '';
  
  // Remove any existing dashes
  const cleaned = code.replace(/-/g, '');
  
  // If 8 characters, format as XXXX-XXXX
  if (cleaned.length === 8) {
    return `${cleaned.substring(0, 4)}-${cleaned.substring(4)}`;
  }
  
  // If already has dash in right place (9 chars total), return as-is
  if (code.includes('-') && code.length === 9) {
    return code;
  }
  
  return code;
};

/**
 * Check if content contains a target code (with or without dash)
 * @param content - The content string to search
 * @param targetCode - The target code to look for
 * @returns Whether the content contains the target code
 */
export const contentContainsTargetCode = (content: string, targetCode: string): boolean => {
  const formattedCode = formatTargetCode(targetCode);
  const cleanedCode = targetCode.replace(/-/g, '');
  const upperContent = content.toUpperCase();
  return upperContent.includes(formattedCode.toUpperCase()) || 
         upperContent.includes(cleanedCode.toUpperCase());
};
